<template>
  <section class="flex-none w-1/3 mdsm:hidden">
    <div class="box box-extended is-cyan p-6 bg-white">
      <h4 class="font-bold fs-20">Yacht details</h4>

      <template v-if="supplierInfo.vessel_length">
        <p class="text-black-light-5 mt-2">Size</p>
        <p v-text="`${supplierInfo.vessel_length}m`" />
      </template>

      <p class="text-black-light-5 mt-2">No. of guests</p>
      <p v-text="guest" />

      <template v-if="supplierInfo.crew">
        <p class="text-black-light-5 mt-2">Crew</p>
        <p v-text="supplierInfo.crew" />
      </template>

      <template v-if="supplierInfo.launch_date && supplierInfo.launch_date !== '-'">
        <p class="text-black-light-5 mt-2">Launched</p>
        <p v-text="supplierInfo.launch_date" />
      </template>

      <template v-if="supplierInfo.renovation_date && supplierInfo.renovation_date !== '-'">
        <p class="text-black-light-5 mt-2">Renovation date</p>
        <p v-text="supplierInfo.renovation_date" />
      </template>
      
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import get from 'lodash/get'

export default {
  computed: {
    ...mapState(['supplier']),
    ...mapGetters(['cabinLabel','guestLabel']),
     supplierInfo() {
      return get(this.supplier, 'supplier', [])
    },
    guest() {
      return (
        this.supplierInfo.number_of_cabins +
        " " +
        this.cabinLabel +
        ", up to " +
        this.supplierInfo.max_occupancy +
        " " +
        this.guestLabel
      );
    },
  }
}
</script>